(function () {
  angular.module("akitabox.room.detail").run(states);

  /* @ngInject */
  function states(Router) {
    Router.configureStates([
      {
        state: "app.building.room.detail",
        config: {
          url: "",
          templateUrl: "app/mobile/modules/room/detail/detail.html",
          controller: "RoomDetailController",
          controllerAs: "vm",
          data: {
            pageTitle: "Room",
          },
        },
      },
    ]);
  }
})();
